import EditLayout from "@/layouts/edit";

// Pages
import EditRecipePage from "@/pages/library/recipes/edit_recipe";


export const editRoutes = {
  element: <EditLayout />,
  children: [
    {
      path: "library",
      children: [
          {
            path: "recipes/:id",
            element: <EditRecipePage />
          }
      ]
    }
  ]
};